






































































































































































































import Vue from "vue";
// @ts-ignore
import { Base64 } from "js-base64";
import { Form } from "element-ui";
import { axios } from "@/plugins";

enum DataType {
  "TLS" = "TLS",
  "REGISTRY_SECRET" = "REGISTRY_SECRET",
  "BASIC_AUTH_SECRET" = "BASIC_AUTH_SECRET",
  "KEY_VALUE_SECRET" = "KEY_VALUE_SECRET"
}

export default Vue.extend({
  name: "KeysEdit",
  props: { projectId: { type: String } },
  data() {
    const checkData = (
      rule: any,
      value: any,
      callback: (err?: string) => {}
    ) => {
      if (
        (this as any).ruleForm.type === "KEY_VALUE_SECRET" &&
        !(Object.keys((this as any).ruleForm.data).length > 0)
      ) {
        callback("data不能为空");
      }
      callback();
    };
    return {
      dialog: false,
      isEdit: false,
      loading: false,
      // 键值对输入框对应值
      key: "",
      value: "",

      ruleForm: {
        name: "",
        description: "",
        type: "KEY_VALUE_SECRET" as DataType,
        data: {} as any
      },
      rules: {
        name: [
          { required: true, type: "string", pattern: /^(?!-)[a-z0-9-]*[^-]$/ }
        ],
        data: [{ required: true, validator: checkData, trigger: "blur" }],
        crt: [{ required: true, type: "string", trigger: "blur" }],
        key: [{ required: true, type: "string", trigger: "blur" }],
        url: [
          {
            required: true,
            type: "string",
            trigger: "change",
            pattern: /^(?!http(s)?:\/\/)(?!.*\/$)[A-Za-z0-9/-_:.]*$/
          }
        ],
        username: [{ required: true, type: "string", trigger: "blur" }],
        password: [{ required: true, type: "string", trigger: "blur" }]
      }
    };
  },
  computed: {
    list() {
      return Object.entries((this as any).ruleForm.data);
    }
  },
  watch: {
    "ruleForm.type"(val: DataType) {
      if (!this.isEdit) {
        switch (val) {
          case "KEY_VALUE_SECRET":
            this.ruleForm.data = {};
            break;
          case "TLS":
            this.ruleForm.data = {
              key: "",
              crt: ""
            };
            break;
          case "BASIC_AUTH_SECRET":
            this.ruleForm.data = {
              username: "",
              password: ""
            };
            break;
          case "REGISTRY_SECRET":
            this.ruleForm.data = {
              method: "http://",
              url: "",
              username: "",
              password: ""
            };
            break;
        }
      }
    }
  },
  methods: {
    show(data?: any) {
      if (data) {
        // 编辑模式
        this.ruleForm.name = data.metadata.name;
        this.ruleForm.description =
          data.metadata.annotations &&
          data.metadata.annotations["appmgr.object.description"];
        this.ruleForm.type = data.metadata.annotations["appmgr.secrets.type"];
        const Data = Object.assign({}, data.data);
        this.initData(Data);
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.dialog = true;
    },
    // 键值对 添加到 data
    addKvData() {
      //
      if (!this.key || !this.value) {
        this.$message.error("键值对的不能为空");
        return;
      }

      this.$set(this.ruleForm.data, this.key, this.value);
      this.key = this.value = "";
    },
    // 键值对 删除 某项
    delKvData(key: string) {
      delete this.ruleForm.data[key];
      // 此处浅拷贝是为了触发页面刷新
      this.ruleForm = Object.assign({}, this.ruleForm);
    },
    quit() {
      this.key = this.value = "";
      this.ruleForm = (this as any).$options.data().ruleForm;
      (this.$refs.ruleForm as Form).resetFields();
      this.dialog = false;
    },
    submit() {
      (this.$refs.ruleForm as Form).validate(vakid => {
        if (vakid) {
          this.loading = true;
          if (this.isEdit) {
            this.edit();
          } else {
            this.create();
          }
        }
      });
    },
    edit() {
      axios
        .put("/secret", this.buildData())
        .then(() => {
          this.$message.success("密钥修改成功");
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    create() {
      axios
        .post("/secret", this.buildData())
        .then(() => {
          this.$message.success("密钥创建成功");
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 构建接口数据类型
    buildData() {
      const { name, description, type, data } = this.ruleForm;
      const resData = {
        projectId: this.projectId,
        name,
        description,
        type
      };
      switch (type) {
        case "KEY_VALUE_SECRET":
          return {
            ...resData,
            data: Object.fromEntries(
              Object.entries(data).map(([key, value]) => [
                key,
                Base64.encode(value)
              ])
            )
          };
        case "TLS":
          return {
            ...resData,
            data: {
              "tls.key": Base64.encode(data.key),
              "tls.crt": Base64.encode(data.crt)
            }
          };
        case "REGISTRY_SECRET":
          return {
            ...resData,
            data: {
              ".dockerconfigjson": Base64.encode(
                JSON.stringify({
                  auths: {
                    [`${data.method}${data.url}`]: {
                      username: data.username,
                      password: data.password
                    }
                  }
                })
              ),
              type: "HARBOR"
            }
          };
        case "BASIC_AUTH_SECRET":
          return {
            ...resData,
            data: {
              username: Base64.encode(data.username),
              password: Base64.encode(data.password)
            }
          };
      }
    },
    initData(data: any) {
      switch (this.ruleForm.type) {
        case "KEY_VALUE_SECRET": {
          for (const key in data) {
            data[key] = Base64.decode(data[key]);
          }
          this.ruleForm.data = { ...data };
          break;
        }
        case "TLS":
          this.ruleForm.data = {
            key: Base64.decode(data["tls.key"]),
            crt: Base64.decode(data["tls.crt"])
          };
          break;
        case "BASIC_AUTH_SECRET":
          this.ruleForm.data = {
            username: Base64.decode(data["username"]),
            password: Base64.decode(data["password"])
          };
          break;
        case "REGISTRY_SECRET": {
          const dockerConfig = JSON.parse(
            Base64.decode(data[".dockerconfigjson"])
          );
          const url = Object.keys(dockerConfig.auths)[0];
          const method = url.indexOf("https") > -1 ? 1 : 0;
          this.ruleForm.data = {
            method: method ? "https://" : "http://",
            url: method ? url.substr(8) : url.substr(7),
            username: dockerConfig.auths[url].username,
            password: dockerConfig.auths[url].password
          };
          break;
        }
      }
    }
  }
});
